import * as $ from 'jquery';
import {Bounce, Sine, TimelineLite, TweenLite} from "gsap";

const activated = [ TweenLite, TimelineLite, Sine, Bounce ];

export class NewsletterSignupComponent
{
    protected $root: JQuery;
    protected tl:TimelineLite;
    protected $fieldsContainer: JQuery;
    protected $successMessage: JQuery;
    protected $content:JQuery;

    constructor(elem: HTMLElement)
    {
        this.$root            = $(elem);
        this.$fieldsContainer = $('.js-newsletter-form__fields', this.$root);
        this.$successMessage  = $('.js-newsletter-form__success-message', this.$root);
        this.$content         = $('.js-newsletter-form__content', this.$root);
        this.bindUI();
    }

    bindUI = () => {
        this.unlockForm();
        this.$root.on({ 'recaptcha-ready': this.setupRecaptcha });
    };

    setupRecaptcha = () => {
        let $recaptcha = this.$root.find('.js-recaptcha').first();
        if ($recaptcha.length > 0) {
            this.$root.on({
                submit: (event: any) => {
                    event.preventDefault();
                    grecaptcha.execute();
                }
            });
            grecaptcha.render($recaptcha.attr("id"), {
                "sitekey": (<any>window).params['recaptcha_key'],
                'badge': 'inline',
                'size': 'invisible'
            });
        } else {
            this.$root.on({ submit: this.handleSubmit });
        }
    };

    handleSubmit = (token:any = '') => {
        let params:any = this.$root.serializeArray();
        params['g-recaptcha-response'] = token;
        this.resetForm();
        this.lockForm();
        $.ajax({url: (<any>window).params.ajax_url, data: params, method: 'POST' })
            .then(
                this.handleResponse,
                (err) => {
                    window.scrollTo(0, 0);
                    this.handleErrors(['There was problem. Please check your internet connection and try submitting again.']);
                }
            );
    };

    private resetForm = () => {
        this.$root.find('.js-newsletter-form__error').remove();
        this.$root.find('.js-newsletter-form__errors').find('p').remove();
    };

    private lockForm = () => {
        this.$root.addClass('c-mailinglist-signup__form--submitting');
        this.$root.find('input,select,textarea').attr('disabled', 'disabled');
    };

    private unlockForm = () => {
        this.$root.removeClass('c-mailinglist-signup__form--submitting');
        this.$root.find('input,select,textarea').removeAttr('disabled');
    };

    private handleErrors = (errors:any) => {
        errors.forEach((err:string) => {
            this.unlockForm();
            this.$fieldsContainer.append('<p class="l-form__error-message js-newsletter-form__error"><strong>Oops</strong> - ' + err + '</p>');
        }).then(
            () => {
                grecaptcha.reset();
                this.unlockForm();
            }
        );
    };

    private handleResponse = (jsonResponse:string) => {
        let result:any = JSON.parse(jsonResponse);
        if (result.status === 'error') {
            this.handleErrors([ result.message ]);
        } else {
            this.handleSuccess();
            this.unlockForm();
        }
    };

    private handleSuccess = () => {

        let tl = new TimelineLite({ delay: 0.2, onComplete: () => {
                this.$fieldsContainer.remove();
                TweenLite.set(this.$content, { clearProps: 'all' });
            } });

        this.$content.css('height', this.$fieldsContainer.height() + 'px');
        this.$fieldsContainer.addClass('u-notransition');

        tl.to(this.$fieldsContainer, 0.5, { opacity: 0, display: 'none', ease: Sine.easeOut })
            .add(() => { this.$successMessage.show(); })
            .add(() => { this.$content.css('height', this.$successMessage.height() + 'px'); }, '+=0.2')
            .to(this.$successMessage, 0.4, { opacity: 1, ease: Sine.easeOut });
    }
}